// library imports
import { Progress, Tag, Flex } from "antd";
import { useContext } from "react";
// style imports
import "../../styles/Dashboard/SummaryCard.css";
// config imports
import {
  DARK_BLUE,
  DARK_GREEN,
  LIGHT_GREEN,
  DARK_THEME_DARK_BLUE,
  PURPLE,
} from "../../configs/configs";
// context imports
import { IndexContext } from "../../context/IndexContext";

export default function _SingleContent({
  title = "-",
  total = "-",
  var1label = "-",
  var2label = "-",
  var3label = "-",
  var1value = "-",
  var2value = "-",
  var3value = "-",
  unit = "-",
}) {
  const { isLightTheme } = useContext(IndexContext);

  let percentage1 = "-";
  let percentage2 = "-";
  let percentage3 = "-";

  if (total !== "-") {
    if (var1value !== "-") {
      percentage1 = 100 * (var1value / total);
    }
    if (var2value !== "-") {
      percentage2 = 100 * (var2value / total);
    }
    if (var3value !== "-") {
      percentage3 = 100 * (var3value / total);
    }
  }

  return (
    // title and total
    <div className="summary-content-content-container">
      <span>
        {title}:
        <span className="summary-content-value">
          {total !== "-"
            ? `${parseFloat(total).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${unit}`
            : `${total}`}
        </span>
      </span>

      {/* progress bar */}
      {var3label === "-" ? (
        <Progress
          percent={percentage1}
          strokeColor={DARK_GREEN}
          trailColor={isLightTheme ? DARK_BLUE : DARK_THEME_DARK_BLUE}
          showInfo={false}
          size={["100%", 20]}
        />
      ) : percentage1 !== "-" && percentage2 !== "-" && percentage3 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: DARK_GREEN,
              flex: percentage1,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 3,
            }}
          />
          <div
            style={{
              height: "20px",
              backgroundColor: PURPLE,
              flex: percentage3,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 2,
            }}
          />
          <div
            style={{
              height: "20px",
              backgroundColor: isLightTheme ? DARK_BLUE : DARK_THEME_DARK_BLUE,
              flex: percentage2,
              borderTopRightRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          />
        </Flex>
      ) : percentage1 !== "-" && percentage2 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: DARK_GREEN,
              flex: percentage1,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
          <div
            style={{
              height: "20px",
              backgroundColor: isLightTheme ? DARK_BLUE : DARK_THEME_DARK_BLUE,
              flex: percentage2,
              borderTopRightRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          />
        </Flex>
      ) : percentage1 !== "-" && percentage3 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: DARK_GREEN,
              flex: percentage1,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
          <div
            style={{
              height: "20px",
              backgroundColor: PURPLE,
              flex: percentage3,
              borderTopRightRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          />
        </Flex>
      ) : percentage2 !== "-" && percentage3 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: isLightTheme ? DARK_BLUE : DARK_THEME_DARK_BLUE,
              flex: percentage2,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
          <div
            style={{
              height: "20px",
              backgroundColor: PURPLE,
              flex: percentage3,
              borderTopRightRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          />
        </Flex>
      ) : percentage1 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: DARK_GREEN,
              flex: percentage1,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
        </Flex>
      ) : percentage2 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: isLightTheme ? DARK_BLUE : DARK_THEME_DARK_BLUE,
              flex: percentage2,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
        </Flex>
      ) : percentage3 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: PURPLE,
              flex: percentage3,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
        </Flex>
      ) : null}

      {/* var 1 */}
      <div className="summary-content-detail">
        <Tag color={DARK_GREEN}></Tag>

        <span>
          {var1label}:
          <span className="summary-content-value">
            {var1value !== "-"
              ? `${parseFloat(var1value).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} ${unit}`
              : `${var1value}`}
          </span>
        </span>

        <span className="summary-content-percentage">
          {percentage1
            ? percentage1 === "-"
              ? "-"
              : `${percentage1.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} %`
            : percentage1 === 0
            ? `${percentage1.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} %`
            : null}
        </span>
      </div>

      {/* var 3 */}
      {var3label !== "-" ? (
        <div className="summary-content-detail">
          <Tag color={PURPLE}></Tag>

          <span>
            {var3label}:
            <span className="summary-content-value">
              {var3value !== "-"
                ? `${parseFloat(var3value).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} ${unit}`
                : `${var3value}`}
            </span>
          </span>
          <span className="summary-content-percentage">
            {percentage3
              ? percentage3 === "-"
                ? "-"
                : `${percentage3.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} %`
              : percentage3 === 0
              ? `${percentage3.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} %`
              : null}
          </span>
        </div>
      ) : (
        <></>
      )}

      {/* var 2 */}
      <div className="summary-content-detail">
        <Tag
          color={
            title === "System production (AC)"
              ? LIGHT_GREEN
              : isLightTheme
              ? DARK_BLUE
              : DARK_THEME_DARK_BLUE
          }
        ></Tag>

        <span>
          {var2label}:
          <span className="summary-content-value">
            {var2value !== "-" ? (
              <>
                {parseFloat(var2value).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                {unit}{" "}
              </>
            ) : (
              `${var2value}`
            )}
          </span>
        </span>
        <span className="summary-content-percentage">
          {percentage2
            ? percentage2 === "-"
              ? "-"
              : `${percentage2.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} %`
            : percentage2 === 0
            ? `${percentage2.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} %`
            : null}
        </span>
      </div>
    </div>
  );
}
